/**
 * Test ID utilities for AlertDialog component
 *
 * Pattern: All test IDs are generated via named setter functions.
 * This ensures consistency between components and tests.
 */

import { generateTestId } from "@client-shared";

/**
 * Generate test ID for AlertDialog trigger
 * @param identifier - AlertDialog identifier
 * @returns Test ID string
 */
export const setAlertDialogTriggerTestId = (identifier: string): string =>
  generateTestId("AlertDialogTrigger", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AlertDialog content
 * @param identifier - AlertDialog identifier
 * @returns Test ID string
 */
export const setAlertDialogContentTestId = (identifier: string): string =>
  generateTestId("AlertDialogContent", identifier.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AlertDialog action button
 * @param label - Button label
 * @returns Test ID string
 */
export const setAlertDialogActionTestId = (label: string): string =>
  generateTestId("AlertDialogAction", label.replace(/\s+/g, "-").toLowerCase());

/**
 * Generate test ID for AlertDialog cancel button
 * @param label - Button label (default: 'cancel')
 * @returns Test ID string
 */
export const setAlertDialogCancelTestId = (label: string = "cancel"): string =>
  generateTestId("AlertDialogCancel", label.replace(/\s+/g, "-").toLowerCase());
